import React, {PropsWithRef, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState} from 'react';
import {add, differenceInDays, endOfMonth} from "date-fns";
import IReservationCalendrier from "../../models/IReservationCalendrier";
import "./calendrier.css";
import {useCalendrierProps} from "./calendrier";
import {TypeCalendrier} from './calendrier-interfaces';
import {IonIcon} from "@ionic/react";
import {informationCircleOutline, informationCircleSharp, informationOutline} from "ionicons/icons";
import Guid from "../../models/Guid";

interface ICalendrierReservationCellProps {
    reservation: IReservationCalendrier,
    cellDebutOffsetTop?: number
    cellDebutOffsetLeft?: number
    cellDebutOffsetHeight?: number
    cellFinOffsetWidth?: number
    cellFinOffsetLeft?: number
}

const CalendrierReservationCell = ({reservation, cellDebutOffsetLeft, cellDebutOffsetTop, cellFinOffsetWidth, cellFinOffsetLeft, cellDebutOffsetHeight}: ICalendrierReservationCellProps) => {
    const {nbColonne, dateCourrante, typeCalendrier, selectedReservation, setSelectedReservation, setIsPopupReservationOpen, paramCopierColler} = useCalendrierProps();
    const cellRef = useRef<any>(null);

    const dateFinCalendrier = add(dateCourrante, {[typeCalendrier === TypeCalendrier.Jours ? "days" : "months"]: nbColonne - 1})
    let date = reservation.dateFin
    const dateFinReservation = new Date(date.getFullYear(), date.getMonth(), typeCalendrier === TypeCalendrier.Jours ? date.getDate() : endOfMonth(date).getDate());
    const isSelected = selectedReservation?.idReservationDetail.toString() === reservation.idReservationDetail.toString();
    date = reservation.dateDebut
    const dateDebutReservation = new Date(date.getFullYear(), date.getMonth(), typeCalendrier === TypeCalendrier.Jours ? date.getDate() : 1);
    const offsetTop = (cellDebutOffsetTop || 0);
    const offsetLeft = (cellDebutOffsetLeft || 0);

    const cellStyle = useMemo(() => {
        return {
            backgroundColor: reservation.couleurEtatBackground,
            color: reservation.couleurEtatTexte,
        }
    }, [reservation.couleurEtatBackground, reservation.couleurEtatTexte])

    if (!(dateDebutReservation >= dateCourrante || dateFinReservation > dateCourrante || dateFinReservation >= dateFinCalendrier) || !cellDebutOffsetLeft || !cellFinOffsetWidth || !cellFinOffsetLeft) {
        return null;
    }
    const isCopier = reservation?.idReservationDetail.equals(paramCopierColler?.idAuxiliaireSource);
    return (
        <div className={`reservation-cell ${selectedReservation?.idReservationDetail.equals(reservation.idReservationDetail) ? 'selected' : ''}`}
             ref={cellRef} key={`reservation-${reservation.idReservationDetail}`}
             onMouseUp={(e: React.MouseEvent<HTMLDivElement>) => {
                 setSelectedReservation(reservation)
             }}
            /*onClick={() => {
                // console.log(reservation)
                setSelectedReservation(reservation)
            }}*/>
            <div className={`cell`}
                 title={`${reservation.noConfirmation} ${reservation.label}`}
                 style={{
                     position: "absolute",
                     top: `calc(${offsetTop}px + 1px)`,
                     left: `calc(${offsetLeft}px + 2px)`,
                     height: `calc(${cellDebutOffsetHeight}px - 3px`,
                     border: 0,
                     width: `calc(${(cellFinOffsetLeft + (reservation.dateFin < dateFinCalendrier && typeCalendrier === TypeCalendrier.Jours ? cellFinOffsetWidth : 0)) - (cellDebutOffsetLeft) + (typeCalendrier === TypeCalendrier.Mois || dateFinReservation > dateFinCalendrier ? (cellFinOffsetWidth) : 0)}px - 2px) `
                 }} id={`${reservation.idReservationDetail}==${reservation.idUnite}`}
                 onDoubleClick={() => setIsPopupReservationOpen(true)}
            >
                <div style={{position: "relative"}}>
                    {reservation.reservationBloquee || isCopier ? <div style={{position: "absolute"}}>
                        <div style={{borderBottomLeftRadius: "4px", borderTopLeftRadius: "4px"}} className={`${isCopier ? "reservation-cell-copier" : "reservation-cell-border-color"}`}></div>
                        <div className={`after-arrow ${isCopier ? "reservation-cell-copier" : "reservation-cell-border-color"}`}></div>
                    </div> : null}
                    <div className={"cell-texte-reservation"} style={{position: "absolute", padding: reservation.reservationBloquee || isCopier ? "2px" : "0", zIndex: 99999}}>
                        <div style={{...cellStyle, paddingLeft: "5px", borderBottomLeftRadius: "4px", borderTopLeftRadius: "4px"}}>
                            {reservation.hasNote && <IonIcon style={{stroke: "1px solid bleu", color: "#ffffff", fontSize: "1.2rem", marginLeft: "-2px", paddingRight: "0.2rem", minWidth: "20px"}} icon={informationCircleSharp}/>}
                            <span style={{overflow: "hidden", textOverflow: "ellipsis"}}>{reservation.label}</span>
                        </div>
                        <div style={cellStyle} className={"after-arrow"}></div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default CalendrierReservationCell;